import script from "./DetalleFlyschView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleFlyschView.vue?vue&type=script&setup=true&lang=js"

import "./DetalleFlyschView.vue?vue&type=style&index=0&id=2e8d9e74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e8d9e74"]])

export default __exports__